import { removeDupes, cleanObject } from '../utils/helpers';

const taskGroups = (state = {
    items: [],
    fetchInfo: {
        project: {}
    }
}, action) => {
    if (action.error) {
        return state;
    }

    switch (action.type) {
        case 'TEAM_CHANGE':
            return {
                items: [],
                fetchInfo: {
                    project: {}
                }
            };

        case 'MARK_ALL_FOR_REFETCH':
            return Object.assign({}, state, {
                items: [...state.items.map(taskGroup => ({
                    ...taskGroup,
                    shouldRefetch: true
                }))]
            });

        case 'TASK_GROUPS_FETCH_REQUESTED':
            return Object.assign({}, state, {
                fetchInfo: {
                    ...state.fetchInfo,
                    project: {
                        ...state.fetchInfo.project,
                        [action.payload.projectId]: {
                            ...(state.fetchInfo.project[action.payload.projectId] || {}),
                            loading: true
                        }
                    }
                }
            });

        case 'TASK_GROUPS_FETCH_SUCCEEDED':
            return Object.assign({}, state, {
                items: removeDupes([
                    ...action.payload.taskGroups,
                    ...state.items
                ]),
                fetchInfo: {
                    ...state.fetchInfo,
                    project: {
                        ...state.fetchInfo.project,
                        [action.payload.projectId]: {
                            loading: false,
                            fetched: true
                        }
                    }
                }
            });

        case 'TASK_GROUPS_FETCH_FAILED':
            return Object.assign({}, state, {
                fetchInfo: {
                    ...state.fetchInfo,
                    project: {
                        ...state.fetchInfo.project,
                        [action.payload.projectId]: {
                            loading: false,
                            error: true
                        }
                    }
                }
            });

        case 'TASK_GROUP_CREATE_REQUESTED':
        case 'TASK_GROUP_ADD_SOCKET':
            // Don't modify if exists
            if (action.payload.taskGroup.id && state.items.find(taskGroup => taskGroup.id === action.payload.taskGroup.id)) {
                return state;
            }

            return Object.assign({}, state, {
                items: [...state.items, action.payload.taskGroup]
            });

        case 'TASK_GROUP_CREATE_SUCCEEDED':
            return Object.assign({}, state, {
                items: state.items
                    .filter(taskGroup => taskGroup.id !== action.payload.taskGroup.id)
                    .map(taskGroup => {
                        if (taskGroup === action.payload.fragment) {
                            taskGroup.id = action.payload.taskGroup.id;
                        }

                        return taskGroup;
                    })
            });

        case 'TASK_GROUP_CREATE_FAILED':
            return Object.assign({}, state, {
                items: state.items.filter(taskGroup => taskGroup !== action.payload.fragment)
            });

        case 'TASK_GROUP_FETCH_REQUESTED':
            return Object.assign({}, state, {
                items: [...state.items.filter(taskGroup => taskGroup.id !== action.payload.taskGroupId), {
                    ...(state.items.find(taskGroup => taskGroup.id === action.payload.taskGroupId) || {}),
                    id: action.payload.taskGroupId,
                    loading: true
                }]
            });

        case 'TASK_GROUP_FETCH_FAILED':
            return Object.assign({}, state, {
                items: [...state.items.filter(taskGroup => taskGroup.id !== action.payload.taskGroupId), {
                    id: action.payload.taskGroupId,
                    error: true,
                    removed: action.payload.removed
                }]
            });

        case 'TASK_GROUP_FETCH_SUCCEEDED':
            return Object.assign({}, state, {
                items: [...state.items.filter(taskGroup => taskGroup.id !== action.payload.taskGroup.id), action.payload.taskGroup]
            });

        case 'TASK_GROUP_UPDATE_REQUESTED':
        case 'TASK_GROUP_UPDATE_SOCKET':
            return Object.assign({}, state, {
                items: [...state.items].map(taskGroup => {
                    if (taskGroup.id === action.payload.taskGroupId) {
                        return Object.assign({}, taskGroup, cleanObject(action.payload.taskGroupProps || action.payload.taskGroup));
                    }

                    return taskGroup;
                })
            });

        case 'TASK_GROUPS_REORDER_SOCKET':
            return Object.assign({}, state, {
                items: [...state.items].map(taskGroup => {
                    const updatedTaskGroup = action.payload.taskGroups.find(tg => tg.id === taskGroup.id);
                    if (updatedTaskGroup) {
                        return Object.assign({}, taskGroup, {
                            order: updatedTaskGroup.order
                        });
                    }

                    return taskGroup;
                })
            });

        case 'TASK_GROUP_REMOVE_REQUESTED':
        case 'TASK_GROUP_REMOVE_SOCKET':
            return Object.assign({}, state, {
                items: [...state.items].map(taskGroup => {
                    if (taskGroup.id === action.payload.taskGroupId) {
                        return {
                            id: taskGroup.id,
                            removed: true
                        };
                    }

                    return taskGroup;
                })
            });

        case 'TASK_GROUP_ASSIGN_REQUESTED':
            return Object.assign({}, state, {
                items: [...state.items].map(taskGroup => {
                    if (taskGroup.id === action.payload.taskGroupId) {
                        return Object.assign({}, taskGroup, {
                            assignees: [...new Set([...(taskGroup.assignees || []), ...action.payload.assignees])]
                        });
                    }

                    return taskGroup;
                })
            });

        case 'TASK_GROUP_UNASSIGN_REQUESTED':
            return Object.assign({}, state, {
                items: [...state.items].map(taskGroup => {
                    if (taskGroup.id === action.payload.taskGroupId) {
                        return Object.assign({}, taskGroup, {
                            assignees: taskGroup.assignees.filter(userId => !action.payload.assignees.includes(userId))
                        });
                    }

                    return taskGroup;
                })
            });

        case 'MILESTONE_REMOVE_REQUESTED':
        case 'MILESTONE_REMOVE_SOCKET':
            return Object.assign({}, state, {
                items: [...state.items].map(taskGroup => {
                    if (taskGroup.milestone === action.payload.milestoneId) {
                        return Object.assign({}, taskGroup, {
                            milestone: null
                        });
                    }

                    return taskGroup;
                })
            });

        default:
            return state;
    }
}

export default taskGroups;
